import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["countdown", "resendContainer"];
  static values = { resendUrl: String };

  connect() {
    this.timerDuration = 10; // 10-second timer
    this.timeLeft = this.timerDuration;

    this.updateCountdownMessage(); // Show the correct time immediately
    this.startTimer();
  }

  startTimer() {
    this.updateCountdownMessage();

    this.interval = setInterval(() => {
      this.timeLeft -= 1;
      this.updateCountdownMessage();

      if (this.timeLeft <= 0) {
        clearInterval(this.interval);
        this.showResendMessage();
      }
    }, 1000); // 1-second interval
  }

  updateCountdownMessage() {
    this.countdownTarget.classList.remove("d-none"); // Show countdown only when ready
    this.countdownTarget.innerText = `Please wait ${this.timeLeft} seconds to resend the verification code.`;
  }

  showResendMessage() {
    this.countdownTarget.innerText = ""; // Clear countdown message
    this.countdownTarget.classList.add("d-none"); // Hide countdown

    // Create resend text
    const paragraph = document.createElement("span");
    paragraph.classList.add("text-sm");
    paragraph.innerText = "Didn’t receive the verification code? ";

    // Create resend link
    const resendLink = document.createElement("a");
    resendLink.href = this.resendUrlValue;
    resendLink.innerText = "Resend it now.";
    resendLink.classList.add("text-primary", "font-bold", "text-decoration-underline");
    resendLink.style.cursor = "pointer";
    resendLink.dataset.method = "post";

    paragraph.appendChild(resendLink);
    this.resendContainerTarget.innerHTML = ""; // Clear any previous content
    this.resendContainerTarget.appendChild(paragraph); // Add to resendContainer
    this.resendContainerTarget.classList.remove("d-none"); // Show resend link
  }
}
